import { matchRoutes, Navigate, RouteObject } from "react-router-dom";
// Models
import { PageProps } from "../../models/routing.model";
// Services
import { getRoute, ProtectedRoute } from "./protected-routes.service";
// Icons
import { BsFillChatLeftFill } from "react-icons/bs";
import { FaCalendarAlt } from "react-icons/fa";
import { TbActivityHeartbeat } from "react-icons/tb";
// import { MdHome } from "react-icons/md";
// Pages
import Login from "../../pages/login/Login";
import Main from "../../pages/main/Main";
import Callback from "../../pages/callback/Callback";
import Messages from "../../pages/messages/Messages";
import Appointments from "../../pages/appointments/Appointments";
import TrackHealth from "../../pages/track-health/TrackHealth";
import NotFound from "../../pages/not-found/NotFound";
// import Home from "../../pages/home/Home";
import HealthReportForm from "../../pages/health-report/HealthReportForm";
import HealthReportConfirmation from "../../pages/health-report/HealthReportConfirmation";
import HealthReport from "../../pages/health-report/HealthReport";

// Application routes
const routes: RouteObject[] = [
	{
		path: "login",
		element: <Login id="login" />,
	},
	{
		path: "callback",
		element: <Callback />,
	},
	{
		path: "/",
		element: (
			<ProtectedRoute>
				<Main />
			</ProtectedRoute>
		),
		children: [
			{ index: true, element: <Navigate to="track-health" /> },
			// {
			// 	path: "home",
			// 	element: (
			// 		<Home
			// 			id="home"
			// 			icon={<MdHome />}
			// 			title="HOME.TITLE"
			// 			isModule={true}
			// 		/>
			// 	),
			// },
			{
				path: "health-report",
				element: (
					<HealthReport
						id="health-report"
						icon={<TbActivityHeartbeat fontSize="1.5rem" />}
						title="HEALTH_REPORT.TITLE"
						isModule={true}
						isVisible={false}
					/>
				),
				children: [
					{ index: true, element: <Navigate to="form" /> },
					{
						path: "form",
						element: (
							<HealthReportForm
								id="health-report/form"
								title="PARTICIPANT.SIDEBAR_MENU.0"
								isSubModule={true}
							/>
						),
					},
					{
						path: "confirmation/:action",
						element: (
							<HealthReportConfirmation
								id="health-report/confirmation"
								title="PARTICIPANT.SIDEBAR_MENU.0"
								isSubModule={true}
							/>
						),
					},
				],
			},
			{
				path: "messages",
				element: (
					<Messages
						id="messages"
						icon={<BsFillChatLeftFill />}
						title="MESSAGES.TITLE"
						isModule={true}
					/>
				),
			},
			{
				path: "track-health",
				element: (
					<TrackHealth
						id="track-health"
						icon={<TbActivityHeartbeat fontSize="1.5rem" />}
						title="TRACK_HEALTH.TITLE"
						isModule={true}
					/>
				),
			},
			{
				path: "appointments",
				element: (
					<Appointments
						id="appointments"
						icon={<FaCalendarAlt />}
						title="APPOINTMENTS.TITLE"
						isModule={true}
					/>
				),
			},
			{
				path: "*",
				element: <NotFound id="not-found" />,
			},
		],
	},
];
export const getRoutes = (): RouteObject[] => routes;

/**
 * Routes: route Element props
 * @returns Returns the props of the current route Element
 */
export const getCurrentRouteProps = (pathname: string): PageProps | undefined => {
	const matchedRoutes = matchRoutes(getRoutes(), pathname);

	let routeProps: PageProps | undefined;
	if (matchedRoutes) {
		matchedRoutes.forEach((mRoute) => {
			if (mRoute.pathname === pathname) {
				const route = getRoute(mRoute.route);
				routeProps = route?.routeProps;
			}
		});
	}

	return routeProps;
};
